module.exports = "/images/demo_echoic.png?8b33a019cdba99a8a025e92b1a63dbea";